import TestIcon from "@/assets/icons/Test.svg?react";

export default function Test({ className }: { className?: string }) {
  return (
    <TestIcon className={className ?? "w-4 h-4"} />
  );
}
